import { render, staticRenderFns } from "./WidgetSidebarView.vue?vue&type=template&id=43576533&"
import script from "./WidgetSidebarView.vue?vue&type=script&lang=js&"
export * from "./WidgetSidebarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports